import { Model } from 'modules/core/lib/mobx-rest'

export interface IAccessGroup {
  id: number
  automations_action_id: number
  notifiable_id: number | null
  notifiable_type: string | null
  relation_type: string
  notifiable_ids: number[]
}

export class AccessGroup extends Model<IAccessGroup> {
  static urlRoot() {
    return '/automations/access_groups'
  }
}
